import { Box, Card } from "@mui/material";
import { FlexCenterWrapper } from "./DefaultNoDataWrapper";
import Text from "./Text";
import sIcon from "/public/success-img.png";

const SuccessLottie = () => {
  return (
    <Box width={"100svw"} height={"100svh"}>
      <FlexCenterWrapper>
        <Card
          elevation={5}
          style={{ minWidth: "500px", width: "30%", height: "60%" }}
        >
          <FlexCenterWrapper>
            {/* <Lottie
              animationData={animationData}
              loop
              autoplay
              style={{ width: 300, height: 300 }}
            /> */}
            <img src={sIcon} height={120} width={120} alt="success" />
            <Text mt={2} fontSize={"20px"}>
              Successfully Submitted Screening Form
            </Text>
          </FlexCenterWrapper>
        </Card>
      </FlexCenterWrapper>
    </Box>
  );
};

export default SuccessLottie;
